import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import "component/modal/ExitDialog/styles.scss";

interface ExitDialogModalProps {
  onClose: () => void;
  onLeaveClickHandler: () => void;
  broadcastSwitchDevice: (params: any) => void;
  params?: any;
  switchDevice?: boolean;
}

function ExitDialogModal(props: ExitDialogModalProps) {
  const { onClose, onLeaveClickHandler, broadcastSwitchDevice, params, switchDevice } = props;
  const { t } = useTranslation("translation");
  const modalRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
        onClose();
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  return (
    <div className="exit-container modal" role="dialog">
      <div
        className="modal-dialog modal-dialog-centered"
        role="document"
        ref={modalRef}
      >
        <div className="modal-content">
          <div className="modal-body">
            <p>{t("doYouWantToLeave")}</p>
          </div>
          <div className="modal-footer d-none">
            <span className="">
              <button type="button" className="btn" onClick={onLeaveClickHandler}>
                {t("leave")}
              </button>
            </span>
            <span className="btn-mid">
              <button
                type="button"
                className="btn"
                onClick={() => {
                  broadcastSwitchDevice(params);
                }}
              >
                {t("switchDevice")}
              </button>
            </span>
            <span className="">
              <button
                type="button"
                className="btn btn-danger"
                onClick={() => {
                  onClose();
                }}
              >
                {t("stay")}
              </button>
            </span>
          </div>
          <div className="modal-footer">
            {switchDevice && (
              <div className="row align-content-center stay">
                <div className="col">
                  <button
                    type="button"
                    className="btn btn-danger text-nowrap  w-100"
                    onClick={() => {
                      onClose();
                    }}
                  >
                    {t("stay")}
                  </button>
                </div>
              </div>
            )}
            <div className="row align-content-center">
              {switchDevice ? (
                <div className="col">
                  <button
                    type="button"
                    className="btn text-nowrap  w-100"
                    onClick={() => {
                      broadcastSwitchDevice(params);
                    }}
                  >
                    {t("switchDevice")}
                  </button>
                </div>
              ) : (
                <div className="col">
                  <button
                    type="button"
                    className="btn btn-danger text-nowrap  w-100"
                    onClick={() => {
                      onClose();
                    }}
                  >
                    {t("stay")}
                  </button>
                </div>
              )}
              <div className="col">
                <button
                  type="button"
                  className="btn text-nowrap w-100"
                  onClick={onLeaveClickHandler}
                >
                  {t("leave")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ExitDialogModal;
